import createReactComponent from '../createReactComponent';
export default createReactComponent('line-dashed', 'IconLineDashed', [
  ['path', { d: 'M5 12h2', key: 'svg-0' }],
  ['path', { d: 'M17 12h2', key: 'svg-1' }],
  ['path', { d: 'M11 12h2', key: 'svg-2' }],
]);
